import TmLogicError from '@/core/error/tmLogicError'
import { TmAuthError } from '@/core/error/transport/auth/TmAuthError'

export class TmAuthNeedVerifyEmailError extends TmAuthError {
  public get userId(): string {
    const userId = this.data.data.userId as unknown
    if (!userId) {
      throw new TmLogicError('Not found "userId"')
    }
    if (typeof userId !== 'number') {
      throw new TmLogicError(`"userId" should be type number. Actual type = "${typeof userId}"`)
    }
    return userId.toString()
  }
}
